<template>
  <div class="answer-sheet-box" style="">
      <h2>{{title?title:'测试说明'}}</h2>
      <div style="width:100%;height: 100%;overflow: auto;padding-bottom:240px;">
      <ul v-if="ul">
        <li :class="[sheet_list.length<=1?'on':'']" v-for="(item,index) in sheet_list" :key="index">{{item}}</li>
      </ul>
      <ol v-else>
          <li :class="[sheet_list.length<=1?'on':'']" v-for="(item,index) in sheet_list" :key="index">{{item}}</li>
      </ol>
      <!--  -->
      <div v-if="exclusionList()" class="agreement">
          <div @click="bool=true" :class="['icon',bool?'on':'']"></div>
          <a @click="agreementShow=true">请阅读并同意此温馨提示</a>
      </div>
      </div>
      <!--  -->
      <button :class="[!exclusionList() || bool?'on':'']" @click="beginSheethandle()" >{{btnText?btnText:'开始答题'}}</button>
      <p class="small">新精英生涯（北京）教育科技有限公司提供内容与技术支持</p>
      <!-- 弹出协议说明 -->
      <van-popup class="agreement-box" v-model="agreementShow">
        <div class="agreement-box-content">
            <h2 class="on">温馨提示</h2>
            <h4>欢迎使用本测评。如果您购买了测评用于您的个人发展，则只有当您同意他人或机构查看或使用你的结果时，他人或机构才有使用的权利。如果您的机构，学校或其他个人（以下简称“第三方”）为您购买了此评估，则我们会将您的结果同步给第三方，以促进您的发展和教育。</h4>
            <button class="btn on" @click="bool=true;agreementShow=false" >同意</button>
        </div>
    </van-popup>
  </div>
</template>

<script>
export default {
    data(){
        return{
            bool:true,
            agreementShow:true
        }
    },
    props:['title','sheet_list','btnText','ul'],
    methods:{
        // 测评排除名单
        exclusionList(){
            return (this.$route.query.path!='ceping67') && (this.$route.path!='/ceping72')  && (this.$route.path!='/ceping76')
        },
        beginSheethandle(){
            if(this.bool || this.$route.query.path=='ceping67' || this.$route.path=='/ceping72'|| this.$route.path=='/ceping76'){
                this.$emit("answerBoolhandle",false);
            } else {
                this.agreementShow = true;
            }
        }
    },
}
</script>

<style lang="scss">
body{
    background: #ffffff;
}
.answer-sheet-box{
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    color: #333333;
    padding: 30px 60px;
    text-align: center;
    h2{
        font-size: 44px;
        margin: 80px auto 110px;
        text-align: center;
        letter-spacing: 2px;
    }
    ol{
        list-style-type:none;
        counter-reset:sectioncounter;
        li{
            font-size: 30px;
            line-height: 39px;
            margin-bottom: 40px;
            text-align: left;
            &:last-child{
                margin-bottom: 0px;
            }
        }
        li:before {
            content:counter(sectioncounter) "、"; 
            counter-increment:sectioncounter;
        }
        li.on:before {
            content:""; 
            counter-increment:sectioncounter;
        }
    }
    ul {
        list-style-type:none;
        li{
            font-size: 30px;
            line-height: 39px;
            margin-bottom: 40px;
            text-align: left;
            &:last-child{
                margin-bottom: 0px;
            }
        }
    }
    .agreement{
        display: flex;
        align-items:center;
        text-align:left;
        margin-top:80px;
        .icon{
            width:24px;
            height:24px;
            border:2px solid #999999;
            border-radius:50%;
            margin-right:15px;
        }
        .icon.on{
            background-color:#F57F17;
            border:2px solid #F57F17;
        }
        a{
            color:#F57F17;
            font-size:24px;
            text-decoration: underline;
        }
    }
    button{
        width: 348px;
        line-height: 64px;
        height: 64px;
        background-color: #CCCCCC;
        color: #ffffff;
        border: 0;
        border-radius: 32px;
        font-size: 30px;
        position: absolute;
        bottom: 120px;
        left: 50%;
        transform: translateX(-50%);
    }
    button.on{
        background-color: #EB5032;

    }
    p.small{
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        font-size:16px;
        color:#999999;
        width: 80%;
        text-align: center;
    }
}
.agreement-box{
    width:540px;
    padding:42px 45px 62px;
    border-radius:12px;
    h2{
        margin:0 auto 42px;
        font-size:36px;
        color:#333333;
        font-weight:bold;
        line-height:1;
    }
    h4{
        font-size:26px;
        color:#333333;
        line-height:42px;
        text-align:justify;
        margin-bottom: 118px;
    }
    .btn{
        bottom: 70px;
    }
}
</style>